var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.756 0h67.5v45h-67.5V0Z",
    fill: "#0C590B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.756 0h16.92v45h-16.92V0ZM40.075 19.81l-2.742-.58-1.441 2.4-.3-2.777-2.724-.633 2.549-1.143-.237-2.786 1.88 2.074 2.576-1.09-1.398 2.426 1.846 2.11h-.009Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.103 26.895a10.652 10.652 0 0 1-14.176 5.22 10.731 10.731 0 0 1-5.23-14.247 10.424 10.424 0 0 1 6.276-5.651c-.362.301-.708.62-1.037.958a9.87 9.87 0 0 0 14.176 13.72h-.009Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakFlag);
export default __webpack_public_path__ + "static/media/pak-flag.28df053eb33ec480116febe190770eaf.svg";
export { ForwardRef as ReactComponent };